import React from "react";
import { useSchool } from "../../DataStore/SchoolContext";
import FilterBar from "../../components/Common/FilterBar"; // adjust path
import { useSchWalletBalance } from "../../DataStore/SchWalletBalanceContext";

const WalletBalanceListHead = ({handleExport}) => {
  const { classOptions, residenceOptions } = useSchool();
  const { dispatch, filter, searchText, classId, residenceId } = useSchWalletBalance();

  return (
    <FilterBar
      title="Wallet Balance listing"
      subtitle="List of all students with wallet balances."
      // iconClass="fa fa-list-check"
      controls={[
        {
          type: "search",
          value: searchText,
          placeholder: "Find student in list...",
          width: 280,
          onChange: (e) => dispatch({ type: "searchText", payload: e.target.value }),
          onEnter: filter,
        },
        {
          type: "select",
          value: String(classId ?? ""), // ✅ ensure string match
          placeholder: "Select class..",
          width: 170,
          options: (Array.isArray(classOptions) ? classOptions : []).map((c) => ({
            value: String(c.value),
            label: c.title,
          })),
          onChange: (e) => dispatch({ type: "classId", payload: String(e.target.value) }),
        },
        {
          type: "select",
          value: String(residenceId ?? ""), // ✅ ensure string match
          placeholder: "All residences",
          width: 180,
          options: (Array.isArray(residenceOptions) ? residenceOptions : []).map((r) => ({
            value: String(r.value),
            label: r.title,
          })),
          onChange: (e) => dispatch({ type: "residenceId", payload: String(e.target.value) }),
        },
      ]}
      actions={[
        { label: "Export", iconClass: "fa fa-file-excel text-primary", onClick: handleExport, variant: "secondary" },
        {
          label: "Apply",
          iconClass: "fa fa-filter",
          onClick: filter,
          variant: "primary",
        },
      ]}
    />
  );
};

export default WalletBalanceListHead;
